/**
 * AOR layer filter to apply when zooming to a subordinate AOR from a report.
 *
 * - `null` filter means every AOR is already shown: leave it alone (`undefined` =
 *   no change).
 * - A filter that already includes the AOR: leave it alone.
 * - Otherwise widen the filter so the target polygon is visible without hiding
 *   the AORs already on the map (the report's own AOR in particular).
 */
export function nextAorFilterIds(
  current: string[] | null,
  aorId: string
): string[] | undefined {
  if (current === null) return undefined;
  if (current.includes(aorId)) return undefined;
  return [...current, aorId];
}
